// extracted by mini-css-extract-plugin
export default {"intro":"NtrpScale_intro__RtLqw","levelBlock":"NtrpScale_levelBlock__UdtaK","strengthWeakTable":"NtrpScale_strengthWeakTable__kghA6"};